import script from "./selectBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./selectBox.vue?vue&type=script&setup=true&lang=ts"

import "./selectBox.vue?vue&type=style&index=0&id=52e8f562&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e8f562"]])

export default __exports__